import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {DOMEN} from '../../../../common/constants'
import {FiasRegionsResponse} from '../../types/responses/fias-regions'
import {SearchLocalityRequestInterface} from '../../types/requests/search-locality-request'
import {FiasLocalitySearchResponse} from '../../types/responses/fias-locality-search'

export const fiasApi = createApi({
    reducerPath: 'fiasApi',
    baseQuery: fetchBaseQuery({baseUrl: `${DOMEN}/kias_dictionary/fias`}),
    tagTypes: ['Fias'],
    endpoints: builder => ({
        getRegions: builder.query<FiasRegionsResponse, void>({
            query: () => `/regions`,
        }),
        search: builder.query<FiasLocalitySearchResponse, SearchLocalityRequestInterface>({
            query: body => `/search/${body.regionCode}/${body.namePart}`,
            providesTags: () => {
                return ['Fias']
            },
        }),
    }),
})

export const useGetRegionsQuery = fiasApi.endpoints.getRegions.useQuery
export const useSearchQuery = fiasApi.endpoints.search.useQuery
export const useSearchLazy = fiasApi.endpoints.search.useLazyQuery
